module.exports = __webpack_public_path__ + "static/img/picture19.729233d1.png";